import {Routes, Route} from "react-router-dom"

import { SimuladoraScreen } from "pages/Simuladora/CalcularTaxaServico"
import { ServicosScreen } from "pages/Simuladora/index"

import HomeScreen from "pages/Home"

import * as Links from "constants/links"

export default function SimuladoraRoutes()
{
    return (
        <Routes>
            <Route path={"/"} element={<HomeScreen/>}/>

            <Route path={Links.SERVICOS_TAXAS_CTM24}>
                <Route index element={<ServicosScreen/>}/>
                <Route path={Links.CALCULAR_TAXAS_CTM24}>
                    <Route index element={<SimuladoraScreen/>}/>
                </Route>
            </Route>

        </Routes>
    )
}